import { render, staticRenderFns } from "./RenewalProforma.vue?vue&type=template&id=1b46bd26&scoped=true"
import script from "./RenewalProforma.vue?vue&type=script&lang=js"
export * from "./RenewalProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46bd26",
  null
  
)

export default component.exports